
//   爱逛好店
export default [{
    path: '/loveShop',
    name: 'loveShop',
    meta: {
      index: 2
    },
    component: () => import('@/views/loveShop/index')
  }]
  